import { useQuery } from '@tanstack/react-query';

import { useAppDispatch, useAppSelector } from 'store';

import { startTimer } from 'modules/blok-test';
import { $apiV2 } from 'modules/global';
import { setTestData } from 'modules/national-certificate';

export const useProgressTest = () => {
  const dispatch = useAppDispatch();
  const test = useAppSelector(({ nationalCertificate }) => !nationalCertificate.test);

  return useQuery({
    queryKey: ['progress-national-certificate'],
    queryFn: async () => {
      const { data } = await $apiV2.get(`/nat-certificate/progress`);

      return data;
    },
    onSuccess: data => {
      dispatch(setTestData(data?.data));
      dispatch(startTimer());
    },
    enabled: !!test
  });
};
